import { Component, Input } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PrioritizationChangeOrderVM, PrioritizationChangeTimerVM } from './prioritization.component';

@Component({
    standalone: false,
    selector: 'prioritization-confirm-modal',
    templateUrl: './prioritization-confirm-modal.component.html',
    styleUrls: ['./prioritization-confirm-modal.component.scss']
})
export class PrioritizationConfirmModalComponent {
    @Input() orderChanges: PrioritizationChangeOrderVM[];
    @Input() timerChanges: PrioritizationChangeTimerVM[];

    constructor(public activeModal: NgbActiveModal) { }

    public confirm() {
        this.activeModal.close();
    }
};